import React, { useState } from "react";
import "./EditPost.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useEditBlogPostMutation } from "../../Redux/Blogs/blogApiSlice";

const modules = {
  toolbar: [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
    ["link", "image", "video"],
    ["clean"],
  ],
};

function EditPost({ blogContent, setEditMode }) {
  const id = blogContent._id;
  const [title, setTitle] = useState(blogContent.title);
  const [content, setContent] = useState(blogContent.content);
  const [category, setCategory] = useState(blogContent.category);

  const [editBlogPost, { isLoading, isError, error }] =
    useEditBlogPostMutation();

  const handlePostUpdate = async (e) => {
    e.preventDefault();

    const response = await editBlogPost({
      id,
      title,
      category,
      content,
    }).unwrap();


    if (response.status === 200) {
      setEditMode(false);
    }
  };

  return (
    <div className="editpost">
      <h2>Edit Post</h2>
      <form className="editpost-form">
        <div>
          <label>Category</label>
          <select
            onChange={(e) => setCategory(e.target.value)}
            defaultValue={category}
          >
            <option>Sport</option>
            <option>Romance</option>
            <option>Prose </option>
            <option>Poetry</option>
          </select>
        </div>
        <div>
          <label>Upload Image</label>
          <input
            type="file"
            className="post-img"
            accept=".png, .jpg, .jpeg .webp"
          />
        </div>
        <div>
          <label>Title</label>
          <input
            type="text"
            className="title"
            id="title"
            placeholder="Article Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <div>
          <label>Article Content</label>
          <ReactQuill
            className="quill"
            theme="snow"
            modules={modules}
            value={content}
            onChange={setContent}
            // onKeyUp={console.log(content)}
            placeholder="Content goes here..."
          />
        </div>

        <button type="submit" onClick={handlePostUpdate} className="submit-btn">
          Save Changes
        </button>
      </form>
    </div>
  );
}

export default EditPost;
